import { executeTwoStepEventQueries } from './execute';
import {
  buildDashboardEventQueries,
  eventsDashboardResponseMapper,
  getDashboardEventsInfo,
} from '../converters/eventDashboardApiConverter';
import { applyCache } from '../utils/event/cacheHandler';

const executeDashboardEvents = (unit, executeId) => (dispatch, getState) => {
  const state = getState();
  const eventQueries = buildDashboardEventQueries(state, unit);
  const dashboardEventsInfo = getDashboardEventsInfo(state);

  const execute = (queries) => executeTwoStepEventQueries(queries, executeId, dispatch, getState);

  return applyCache(eventQueries, execute, dispatch, getState).then((response) =>
    eventsDashboardResponseMapper(response, eventQueries, dashboardEventsInfo, unit)
  );
};

export default executeDashboardEvents;
